import {defineStore} from "pinia";

const authData = window._authUser;

export const useAuthStore = defineStore('auth', {
    state: () => ({
        signedIn: authData.signedIn,
        user: authData.user
    }),
    actions: {
        login(payload) {
            this.signedIn = payload.signedIn;
            this.user = payload.user;
        },
        logout() {
            this.signedIn = false;
            this.user = null;
        },
        updateUser(payload) {
            this.user = {...payload};
        }
    }
});
